import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useEditKilnReplacement = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationKey: ['editKilnReplacement'],
    mutationFn: mutations.editKilnReplacement,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditKilnReplacement')
        .extras({errorDetails})
        .error('Error occurred while editing kiln replacement')

      spawnErrorToast(t('error.editKilnReplacement'))
    },
    onSuccess: async (_, {plantUpmId, kilnUpmId, shutdownId}) => {
      await queryClient.invalidateQueries({
        queryKey: [
          'kilnReplacement',
          {
            plantUpmId,
            kilnUpmId,
            shutdownId
          }
        ]
      })
      spawnSuccessToast(t('success.editKilnReplacement'))
    }
  })
}
